<template>
    <local-tree-view ref="treeViewRef" :data-source="menuList" :meta="meta" @item-click="onItemClick">
    </local-tree-view>
</template>

<script>
export default {
    name: 'navigate-menu-view',
};
</script>

<script setup>
import localTreeView from '@/components/local-tree-view.vue';
import { getMenuMainLayoutList } from '@/service/meta-service';
import { onMounted } from 'vue';
import { ref } from 'vue';
import { useRouter } from 'vue-router';

const menuList = ref([]);
const router = useRouter();
const treeViewRef = ref(null);

const flattenArray = arr => {
    return arr.flatMap(item => {
        return [item, ...(item.sub_menu ? flattenArray(item.sub_menu) : [])];
    });
};

onMounted(async () => {
    const data = await getMenuMainLayoutList();
    menuList.value = flattenArray(data);
    setTimeout(() => {
        treeViewRef.value.treeViewInstance.expandAll();
    }, 0);
});

const onItemClick = item => {
    router.push({
        name: item.itemData.route_name,
    });
};

const meta = {
    searchHint: null,
    keyExpr: 'id',
    displayExpr: 'text',
    parentIdExpr: 'id_parent',
    dataStructure: 'plain',
    rootValue: null,
    selectByClick: true,
    selectionMode: 'single',
    expandEvent: 'dbclick',
    itemTemplate: 'item',
    valueChangeEvent: 'keyup',
    animationEnabled: false,
    hideSearch: true,
};
</script>
